/**
 * Shared layout point store. Constellation owns the load lifecycle but
 * publishes the result here so the Drawer's Memories tab can render rows
 * without re-fetching.
 */

import type { LayoutPoint } from './api.svelte'

export const layoutPoints = $state<{
  all: LayoutPoint[]
  computedAt: string | null
  varianceExplained: number[] | null
  elapsedMs: number | null
}>({
  all: [],
  computedAt: null,
  varianceExplained: null,
  elapsedMs: null,
})
